module.exports = __webpack_public_path__ + "media/images/farey/carousel/blog_farey_services-24782e707051b1e8b844c0f2e0892d77.png";